import React, { PureComponent } from 'react';
// import { NavLink } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import PurchaseCmp from '../../shared/components/purchases/purchase-cmp';

export default class EditPurchasePage extends PureComponent {

  constructor() {
    super();
    this.state = {
      purchase_id: ''
    };
  }

  componentDidMount(){
    const { match } = this.props
    this.setState({purchase_id: (match && match.params) ? match.params.purchaseId : '' })
  }

  render(){
    return (<Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Achat</h3>
        </Col>
        <Col md={12}>
          <PurchaseCmp editing={true} match={this.props.match} purchase_id={this.state.purchase_id} history={this.props.history}/>
        </Col>
      </Row>
    </Container>)
  }
}